export const ADD_CLIENT = "ADD_CLIENT"
export const MODIFY_CLIENT = "MODIFY_CLIENT"
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE"